module.exports = __webpack_public_path__ + "media/images/mobile-border-afcbc6fdad3ad94ab91b455a974ee8f7.png";